<ng-container *ngIf="(marketConfig$ | async)?.mspot as name; else defaultLayout">
    <mspot [name]="name"></mspot>
</ng-container>

<ng-template #defaultLayout>
    <div class="row">
        <div class="text-l p-16">
            <ul *ngIf="data">
                <li class="border-b pt-8 pb-8">
                    <span class="title-s ttu" [textContent]="data.common?.title1"></span>&nbsp;
                    <span class="rgpd-content text-l" [textContent]="data.layer?.content1"></span>&nbsp;
                    <a class="title-s ttu" href="{{ data.links?.controller }}" target="_blank" rel="noopener">
                        {{ data.common?.link }}
                    </a>
                </li>
                <li class="border-b pt-8 pb-8">
                    <span class="title-s ttu" [textContent]="data.common?.title2"></span>&nbsp;
                    <span class="rgpd-content text-l" [textContent]="data.layer?.content2"></span>&nbsp;
                    <a class="title-s ttu" href="{{ data.links?.use }}" target="_blank" rel="noopener">
                        {{ data.common?.link }}
                    </a>
                </li>
                <li class="border-b pt-8 pb-8">
                    <span class="title-s ttu" [textContent]="data.common?.title3"></span>&nbsp;
                    <span class="rgpd-content text-l" [textContent]="data.layer?.content3"></span>&nbsp;
                    <a class="title-s ttu" href="{{ data.links?.ground }}" target="_blank" rel="noopener">
                        {{ data.common?.link }}
                    </a>
                </li>
                <li class="border-b pt-8 pb-8">
                    <span class="title-s ttu" [textContent]="data.common?.title4"></span>&nbsp;
                    <span class="rgpd-content text-l" [textContent]="data.layer?.content4"></span>&nbsp;
                    <a class="title-s ttu" href="{{ data.links?.rights }}" target="_blank" rel="noopener">
                        {{ data.common?.link }}
                    </a>
                </li>
                <li class="pt-8 pb-8">
                    <span class="title-s ttu" [textContent]="data.common?.title5"></span>&nbsp;
                    <span class="rgpd-content text-l" [textContent]="data.common?.content5"></span>&nbsp;
                    <a class="title-s ttu" href="{{ data.links?.policy }}" target="_blank" rel="noopener">{{
                        'dev.general.privacyPolicy' | translate
                    }}</a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>
